<template>
  <div class="flex items-center w-full h-full">
    <div class="shrink-0 text-blue-400 font-medium w-[85px] 2xl:w-32">
      <Link
        ref="linkRef"
        :href="route('orders.show', { order: params.orderId })"
      >
        {{ params.referenceNumber }}
      </Link>
    </div>
    <div class="truncate">{{ params.customerName }}</div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Link } from '@inertiajs/vue3'
import { useStopPropagation } from '@/Composables/stop-propagation'

const props = defineProps({
  params: {
    type: Object,
    required: true
  }
})

const linkRef = ref(null)

useStopPropagation({ linkRef })
</script>
